import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconQrScan = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M1.6 22H5.6V23.6H0.8C0.36 23.6 0 23.24 0 22.8V18H1.6V22ZM23.6 22.8C23.6 23.24 23.24 23.6 22.8 23.6H18V22H22V18H23.6V22.8ZM10.8 18.8H4.8V12.8H10.8V18.8ZM18.8 18.8H12.8V12.8H18.8V18.8ZM6.4 17.2H9.2V14.4H6.4V17.2ZM10.8 10.8H4.8V4.8H10.8V10.8ZM18.8 10.8H12.8V4.8H18.8V10.8ZM6.4 9.2H9.2V6.4H6.4V9.2ZM14.4 9.2H17.2V6.4H14.4V9.2ZM5.6 1.6H1.6V5.6H0V0.8C0 0.36 0.36 0 0.8 0H5.6V1.6ZM22.8 0C23.24 0 23.6 0.36 23.6 0.8V5.6H22V1.6H18V0H22.8Z"
	})
});
export default SvgIconQrScan;
